<template>

  <!--div v-show="isLoading" class="loading-overlay">
    <LoadingModal message="Caricamento in corso..." />
  </div>-->
  <div v-show="isLoading">
    <LoadingOverlay :show="isLoading" title="Caricamento in corso..." :message="loadingMessage" />
  </div>

  <div class="top-bar-consultazione">
    {{ $root.activePreLoginView === 'HelpDeskPnrr'
      ? 'Help Desk Appalti PNRR e PNC'
      : 'Consultazione Pareri'
    }}
  </div>
  <div class="question-list p-4">

    <div class="filters-bar bg-white shadow rounded">
      <div class="filters-bar-left">
        <label class="me-2 mb-0 small">Elementi per pagina:</label>
        <select class="form-select form-select-sm w-auto" v-model.number="pagination.perPage"
          @change="loadQuestions(1)">
          <option v-for="n in [10, 25, 50, 100]" :key="n" :value="n">{{ n }}</option>
        </select>
      </div>

      <div class="filters-bar-right no-wrap-filters">
        <div class="filters-field">
          <label class="active mb-1">Filtra per ID:</label>
          <input type="text" class="form-control form-control-sm filter-input" v-model="filterId" placeholder="ID"
            @keyup.enter="applyFilter" />
        </div>

        <div class="filters-field">
          <label class="active mb-1">Filtra per contenuto:</label>
          <input type="text" class="form-control form-control-sm filter-input-wide" v-model="filterText"
            placeholder="Ricerca testuale..." @keyup.enter="applyFilter" />
        </div>

        <div class="dropdown" data-bs-auto-close="outside">
          <button ref="topicsToggle" type="button" class="filter-dropdown dropdown-toggle-custom"
            data-bs-toggle="dropdown" aria-expanded="false">
            {{ selectedTopicsLabel }}
            <i class="bi bi-chevron-down small ms-1"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end p-3 shadow"
            style="min-width:280px; max-height:300px; overflow:auto;" data-bs-auto-close="outside">
            <li>
              <h6 class="dropdown-header fw-bold">Filtra per argomento</h6>
            </li>
            <li v-for="topic in allTopics" :key="topic.id">
              <div class="form-check small" @click.stop>
                <input type="checkbox" class="form-check-input" :id="`topic-${topic.id}`" :value="topic.id"
                  v-model="selectedTopics">
                <label class="form-check-label" :for="`topic-${topic.id}`">
                  {{ topic.title }}
                </label>
              </div>
            </li>
          </ul>
        </div>

        <div class="dropdown" data-bs-auto-close="outside">
          <button ref="articlesToggle" type="button" class="filter-dropdown dropdown-toggle-custom"
            data-bs-toggle="dropdown" aria-expanded="false">
            {{ selectedArticlesLabel }}
            <i class="bi bi-chevron-down small ms-1"></i>
          </button>

          <ul class="dropdown-menu dropdown-menu-end p-3 shadow"
            style="min-width:420px; max-height:300px; overflow:auto;" data-bs-auto-close="outside">
            <li>
              <h6 class="dropdown-header fw-bold">Filtra per articolo</h6>
            </li>
            <li v-for="art in articoli" :key="art.value">
              <div class="form-check small" @click.stop>
                <input type="checkbox" class="form-check-input" :id="`art-${art.value}`" :value="art.value"
                  v-model="selectedArticles">
                <label class="form-check-label" :for="`art-${art.value}`" :title="art.fullLabel">
                  {{ art.label }}
                </label>
              </div>
            </li>
          </ul>
        </div>

        <button type="button" class="btn btn-sm btn-primary icon-btn rounded-circle" @click="applyFilter" title="Cerca"
          :disabled="!filterId && !filterText && !selectedTopics.length && !selectedArticles.length">
          <svg class="icon icon-sm icon-white" aria-hidden="true">
            <use :href="$root.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-search'"></use>
          </svg>
        </button>

        <button class="btn btn-sm btn-outline-secondary icon-btn rounded-circle" @click="resetFilters" title="Reset">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>

    <transition-group name="fade-transition" mode="out-in">
      <div v-if="!isLoading" class="question-table-wrapper">
        <PareriTable :questions="questions" :pagination="pagination" :sort-field="sortField" @change-view="openDetail"
          :sort-direction="sortDirection" :showSearch="false" :state-icons="stateIcons" @page-change="loadQuestions"
          @sort="handleSort" class="it-table-wrapper" />
      </div>
    </transition-group>

  </div>
</template>

<script>
import TableView from '../../../components/common/TableView.vue';
import ModalView from '../../../components/common/ModalView.vue';
import LoadingModal from '../../partials/LoadingModal.vue';
import PareriTable from './partials/PareriTable.vue';
import LoadingOverlay from '../../partials/LoadingOverlay.vue';

export default {
  name: 'ListaPareriConsultabili',
  components: { TableView, ModalView, LoadingModal, PareriTable, LoadingOverlay },
  data() {
    return {
      questions: [],
      pagination: { currentPage: 1, perPage: 10, total: 0, lastPage: 1 },
      sortField: 'id',
      sortDirection: 'desc',
      isLoading: true,
      filterId: '',
      filterText: '',
      selectedTopics: [],
      selectedArticles: [],
      allTopics: [],
      articoli: [],
      selectedQuestion: { object: '', text: '', topics: [] },
      showDetailModal: false,
      columns: [
        { key: 'id', label: 'ID', sortable: true, headerClass: 'bg-primary text-white' },
        { key: 'sending_date', label: 'Data Evasione', sortable: true, headerClass: 'bg-primary text-white' },
        { key: 'articles', label: 'Articoli', headerClass: 'bg-primary text-white' },
        { key: 'object', label: 'Oggetto', sortable: false, headerClass: 'bg-primary text-white' },
      ],
      articleLabelMaxLength: 60,
    };
  },
  /**watch: {
    '$root.listaPareriPresetFilters': {
      deep: true,
      handler(preset) {
        if (!preset) return;

        this.filterId = preset.filterId ?? '';
        this.filterText = preset.filterText ?? '';
        this.selectedTopics = Array.isArray(preset.selectedTopics) ? preset.selectedTopics : [];
        this.selectedArticles = Array.isArray(preset.selectedArticles) ? preset.selectedArticles : [];

        this.$root.listaPareriPresetFilters = null;
        this.loadQuestions(1);
      }
    }
  },*/
  computed: {
    selectedTopicsLabel() {
      if (!this.selectedTopics.length) return 'Argomenti';
      /*if (this.selectedTopics.length === 1) {
        const t = this.allTopics.find(x => x.id === this.selectedTopics[0]);
        return t ? t.title : '1 argomento';
      }*/
      return `Argomenti (${this.selectedTopics.length})`;
    },
    selectedArticlesLabel() {
      if (!this.selectedArticles.length) return 'Articoli';
      /*if (this.selectedArticles.length === 1) {
        const a = this.articoli.find(x => x.value === this.selectedArticles[0]);
        return a ? a.label : '1 articolo';
      }*/
      return `Articoli (${this.selectedArticles.length})`;
    }
  },
  methods: {
    openDetail(view, elementId) {
      this.$emit('change-view', 'ParereView', elementId);
    },

    resetFilters() {
      this.filterId = '';
      this.filterText = '';
      this.selectedTopics = [];
      this.selectedArticles = [];
      this.loadQuestions(1);
    },
    formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleDateString('it-IT');
    },
    formatArticleTitle(title) {
      if (!title) return '';
      const artDotMatch = title.match(/^Art\.\s*(\d+)/i);
      if (artDotMatch) return `Art.${artDotMatch[1]}`;
      const articoloMatch = title.match(/^Articolo\s+(\d+)/i);
      if (articoloMatch) return `Articolo ${articoloMatch[1]}`;
      return title;
    },
    /**openDetail(item) {
      this.selectedQuestion = JSON.parse(JSON.stringify(item));
      this.showDetailModal = true;
    },*/
    applyFilter() {
      this.loadQuestions(1);
    },
    handleSort({ field, direction }) {
      this.sortField = field;
      this.sortDirection = direction;
      this.loadQuestions(1);
    },
    async loadQuestions(page = 1) {
      this.isLoading = true;
      try {
        const params = {
          per_page: this.pagination.perPage,
          page,
          sortField: this.sortField,
          sortDirection: this.sortDirection,
          id: this.filterId || '',
          text: this.filterText || '',
          topics: this.selectedTopics.join(','),
          articles: this.selectedArticles.join(','),
        };

        //const response = await this.$root.$api.get(`/questions/pareri-published`, { params });
        const queryString = new URLSearchParams(params).toString();

        const baseUrl = this.$root.config.VITE_APP_BACKOFFICE_URL.replace(/\/api$/, '');
        const response = await fetch(
          `${baseUrl}/questions/pareri-published?${queryString}`,
          {
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          }
        );



        //const response = await fetch(`${this.$root.config.VITE_APP_BACKOFFICE_URL}/questions/pareri-published`)

        if (!response.ok) {
          const errorText = await response.text();
          console.error('Errore HTTP:', response.status, errorText);
          return;
        }

        const json = await response.json();

        if (!this.$root.contents) {
          await this.$root.fetchContents()
        }

        if (this.$root.contentsLoading) {
          while (this.$root.contentsLoading) {
            await new Promise(resolve => setTimeout(resolve, 100))
          }
        }

        const allArticlesRemote = Object.values(this.$root.contents?.articles || {});

        this.questions = json.data.map(q => {
          if (q.articles?.length) {
            q.articles = q.articles.map(a => {
              const remote = allArticlesRemote.find(r => r.id === a.id);
              const title = remote?.versions?.length
                ? remote.versions[remote.versions.length - 1].title
                : null;
              return { ...a, title };
            });
          }
          return q;
        });

        this.pagination = {
          currentPage: json.current_page,
          perPage: json.per_page,
          total: json.total,
          lastPage: json.last_page
        };


        if (this.allTopics.length === 0 && json.allTopics) {
          this.allTopics = json.allTopics;
        }


        if (this.articoli.length === 0 && json.allArticleIds) {
          this.articoli = allArticlesRemote
            .filter(a => !a.deleted_at && a.versions && a.versions.length > 0)
            .filter(a => json.allArticleIds.includes(a.id))
            .sort((a, b) => a.id - b.id)
            .map(a => {
              const fullTitle = a.versions[a.versions.length - 1].title;
              const max = this.articleLabelMaxLength;
              return {
                value: a.id,
                label: fullTitle.length > max ? fullTitle.slice(0, max) + '...' : fullTitle,
                fullLabel: fullTitle
              };
            });
        }
      } catch (err) {
        console.error('Errore loadQuestions published', err);
      } finally {
        this.isLoading = false;
      }
    }
  },
  async mounted() {
    this.$nextTick(() => {
      const BI = window.bootstrap || window.bootstrapItalia;
      if (BI && BI.Dropdown) {
        if (this.$refs.topicsToggle) {
          BI.Dropdown.getOrCreateInstance(this.$refs.topicsToggle);
        }
        if (this.$refs.articlesToggle) {
          BI.Dropdown.getOrCreateInstance(this.$refs.articlesToggle);
        }

        const filtersBarEl = this.$el?.querySelector?.('.filters-bar');
        const setDropdownOpen = (open) => {
          if (!filtersBarEl) return;
          filtersBarEl.classList.toggle('filters-bar--dropdown-open', open);
        };

        if (this.$refs.topicsToggle) {
          this.$refs.topicsToggle.addEventListener('show.bs.dropdown', () => setDropdownOpen(true));
          this.$refs.topicsToggle.addEventListener('hide.bs.dropdown', () => setDropdownOpen(false));
        }

        if (this.$refs.articlesToggle) {
          this.$refs.articlesToggle.addEventListener('show.bs.dropdown', () => setDropdownOpen(true));
          this.$refs.articlesToggle.addEventListener('hide.bs.dropdown', () => setDropdownOpen(false));
        }
      } else {
        // Fallback: carica Dropdown dal pacchetto
        import('bootstrap-italia').then((mod) => {
          const Dropdown = mod.Dropdown || mod.default?.Dropdown;
          if (Dropdown) {
            if (this.$refs.topicsToggle) Dropdown.getOrCreateInstance(this.$refs.topicsToggle);
            if (this.$refs.articlesToggle) Dropdown.getOrCreateInstance(this.$refs.articlesToggle);
          }
        }).catch(() => {
          console.warn('Bootstrap Italia Dropdown non disponibile');
        });
      }
    });
    /**const preset = this.$root.listaPareriPresetFilters;
    if (preset) {
      this.filterId = preset.filterId ?? '';
      this.filterText = preset.filterText ?? '';
      this.selectedTopics = Array.isArray(preset.selectedTopics) ? preset.selectedTopics : [];
      this.selectedArticles = Array.isArray(preset.selectedArticles) ? preset.selectedArticles : [];

      this.$root.listaPareriPresetFilters = null;
    }*/
    await this.loadQuestions();
  },
};
</script>

<style scoped>
.no-wrap-filters {
  flex-wrap: nowrap !important;
}

.filter-input {
  width: 80px;
}

.filter-input-wide {
  width: 220px;
}

.filter-dropdown {
  cursor: pointer;
  font-size: 0.875rem;
  color: #0d6efd;
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  border: 1px solid #d9e2ec;
  border-radius: 0.25rem;
}

.icon-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
}

.it-table-wrapper table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.it-table-wrapper table thead {
  background-color: #0d6efd !important;
  color: white !important;
}

.it-table-wrapper :deep(tbody tr:hover) {
  background-color: rgba(0, 102, 204, 0.08);
  transition: background-color 0.2s;
}

.modern-table th {
  text-align: center;
  cursor: pointer;
}

.modern-table td {
  text-align: center;
  padding: 0.75rem 1rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.filters-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
}

.filters-search-btn {
  flex: 0 0 auto;
}

.filters-bar {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  padding: 1rem;
  margin: 1rem 0 1.5rem 0;
  width: 100%;
  flex-wrap: nowrap;
  overflow: visible;
  position: relative;
  z-index: 1;
}

.filters-bar.filters-bar--dropdown-open {
  z-index: 2000;
}

.filters-bar-left {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.filters-bar-right {
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
  flex: 1 1 auto;
  min-width: 0;
  justify-content: flex-end;
  flex-wrap: nowrap;
  overflow: visible;
}

.filters-bar-right :deep(.dropdown) {
  position: relative;
  z-index: 2001;
}

.filters-bar-right :deep(.dropdown-menu) {
  z-index: 4000;
}

.filters-field label {
  font-size: 0.75rem;
  line-height: 1;
  white-space: nowrap;
}

@media (max-width: 992px) {
  .filters-bar-right {
    justify-content: flex-end;
    flex-wrap: nowrap;
  }
}

.top-bar-consultazione {
  width: 100vw;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0) 45%),
    linear-gradient(180deg, #2f86ff 0%, #0059b3 45%, #003a7a 100%);
  color: white;
  font-size: 2rem;
  font-weight: bold;
  text-align: left;
  padding: 6rem 4rem;
  padding-left: 20rem;
}
</style>